import { useTranslation } from "react-i18next";

function PermissionRequired() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <div className="max-w-md w-full text-center">
        {/* Title */}
        <h1 className="text-3xl  text-gray-900 mb-4">
          {t("shared.permissionRequired.title", "Permission Denied")}
        </h1>

        {/* Description */}
        <p className="text-gray-600 mb-8 text-lg leading-relaxed">
          {t(
            "shared.permissionRequired.description",
            "You don't have the required permissions to access this page. Please contact your administrator if you believe this is an error."
          )}
        </p>

        {/* Additional Info */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-sm text-gray-500">
            {t(
              "shared.permissionRequired.contactAdmin",
              "Need help? Contact your system administrator."
            )}
          </p>
        </div>
      </div>
    </div>
  );
}

export default PermissionRequired;
